export default __webpack_public_path__ + "static/media/mobile_tilt.b06a663e.svg";